import { createTheme, virtualColor } from '@mantine/core'

const theme = createTheme({
  colors: {
    gray: virtualColor({
      dark: 'grayDark',
      light: 'grayLight',
      name: 'gray',
    }),
    grayDark: [
      '#121113',
      '#1a191b',
      '#232225',
      '#2b292d',
      '#323035',
      '#3c393f',
      '#49474e',
      '#625f69',
      '#6f6d78',
      '#7c7a85',
    ],
    grayLight: [
      '#fdfcfd',
      '#faf9fb',
      '#f2eff3',
      '#eae7ec',
      '#e3dfe6',
      '#dbd8e0',
      '#d0cdd7',
      '#bcbac7',
      '#8e8c99',
      '#84828e',
    ],
    primary: virtualColor({
      dark: 'primaryDark',
      light: 'primaryLight',
      name: 'primary',
    }),
    primaryDark: [
      '#140e1c',
      '#1d1328',
      '#2e1945',
      '#3c1c5b',
      '#47236a',
      '#542d7a',
      '#673b94',
      '#864dc0',
      '#a855f7',
      '#9b47e9',
    ],
    primaryLight: [
      '#fdfcff',
      '#fbf7ff',
      '#f5edff',
      '#efe1ff',
      '#e7d3ff',
      '#ddc2ff',
      '#cfabff',
      '#be8bff',
      '#9333ea',
      '#8427d5',
    ],
  },
  components: {},
  defaultRadius: '5px',
  fontFamily: 'Inter, sans-serif',
  fontSizes: {
    sm: '0.8125rem',
  },
  primaryColor: 'primary',
  primaryShade: 9,
})

export default theme
